module.exports = __webpack_public_path__ + "static/media/motorhome_orange.e6da1cce.svg";